import {FilterKeys, FilterParams} from './ShipmentInterfaces';

export function filterParamsFromURLSearchParams(searchParams: URLSearchParams | null): FilterParams {
  if (!searchParams) return {};

  const params: FilterParams = {};
  searchParams.forEach((value, key) => {
    switch (key) {
      case FilterKeys.DestinationTag:
      case FilterKeys.Sku:
      case FilterKeys.Lpn:
      case FilterKeys.Scac:
      case FilterKeys.Bol:
      case FilterKeys.OutboundFreightManifest:
      case FilterKeys.LoadId:
      case FilterKeys.ProNumber:
      case FilterKeys.CustomerReferenceNumber:
      case FilterKeys.FreightLoadGroup:
      case FilterKeys.LotCode:
        params[key] = value;
        break;
      case FilterKeys.PurchaseOrder:
        params[key] = params[key] ? [...params[key], value] : [value];
        break;
      case FilterKeys.ShipmentId:
        params[key] = params[key] ? [...params[key], parseInt(value, 10)] : [parseInt(value, 10)];
        break;
      case FilterKeys.OrderReferenceId:
      case FilterKeys.FreightLoadId:
        params[key] = parseInt(value, 10);
        break;
      case FilterKeys.ExpirationDate:
        params[key] = new Date(value);
        break;
    }
  });

  return params;
}
